import { BrowserRouter, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { ToastContainer } from "react-toastify";

//helper classes
import helper from "./app/common/helper";

// Local Components
import Loader from "./app/components/Loader";
import "./app.scss";
import { getGlobalData } from "./app/network/api";
import { handleError } from "./app/hooks/useHttps";

const DefaultLayout = lazy(() => import("./app/views/DefaultLayout"));
const Login = lazy(() => import("./app/views/Login/index"));
const Register = lazy(() => import("./app/views/Register/index"));
const ForgotPassword = lazy(() =>
  import("./app/views/ForgotPassword/index")
);
const Page404 = lazy(() => import("./app/components/Page404/index"));
const Page500 = lazy(() => import("./app/components/Page500/index"));

const App = () => {
  // set window with organisation information
  const token = helper.SecureStorageFunc("userToken", "get", "");
  if (token) {
    try {
      getGlobalData(token);
    } catch (err) {
      handleError(err);
    }
  }

  return (
    <BrowserRouter>
      <ToastContainer />
      <Suspense fallback={<Loader />}>
        <Routes>
          {helper.SecureStorageFunc("userToken", "get", "") ? (
            <Route path="*" name="admin" element={<DefaultLayout />} />
          ) : (
            <Route path="/login" name="Login Page" element={<Login />} />
          )}
          <Route
            path="/register"
            name="Register Page"
            //  element={  <Register    />}
            element={<Register />}
          />
          <Route
            path="/ForgotPassword"
            name="Forgot Password"
            element={<ForgotPassword />}
          />
          <Route path="/404" name="Page 404" element={<Page404 />} />
          <Route path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="admin" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
export default App;
